import React from 'react';
import { useNavigate } from 'react-router-dom';

import CustomModal from '@shared/components/modal/CustomModal';
import { CustomButton } from '@shared/buttons';

// TODO: Replace inner content with final UI/UX design
const TrialExpiredGate = () => {
  const navigate = useNavigate();

  const footer = (
    <CustomButton
      color="primary"
      className="btn-lg"
      onClick={() => navigate('/plans-payments')}
    >
      Subscribe to Reforal
    </CustomButton>
  );

  return (
    <CustomModal
      open
      toggle={() => {}}
      title="Your Free Trial Has Ended"
      footer={footer}
      hideCloseButton
      modalProps={{
        centered: true,
        backdrop: 'static',
        keyboard: false,
      }}
    >
      <p className="b1 mb-0">
        Your 3-month free trial has expired. Please subscribe to Clinic Portal
        to continue using Reforal.
      </p>
    </CustomModal>
  );
};

export default TrialExpiredGate;
